module.exports = __webpack_public_path__ + "static/media/faizur.1d3f0111.jpg";